<template>
	<div>
	   <Table class='table' v-if='screenW>400' :loading="loading" stripe :columns="columns" :data="showOrders"></Table>
	    <div v-else class='xs-cells' v-for='order in showOrders'>
	    	<Row class='xs-cells-item' style='margin-top: 0.2rem;'><Col span='12'>訂單日期(Order Date)</Col><Col span='12' style='text-align: center;'>{{order.createTime}}</Col></Row>
	    	<Row class='xs-cells-item' ><Col span='12'>訂單編號(Order Number)</Col><Col span='12' style='text-align: center;'>{{order.orderId}}</Col></Row>
	    	<Row class='xs-cells-item'><Col span='12'>訂單金額/PV(Order Amount/PV)</Col><Col span='12' style='text-align: center;'>{{order.total}}&nbsp;/&nbsp;{{order.PV}}</Col></Row>
	    	<!-- <Row class='xs-cells-item'><Col span='12'>訂單狀態(Order Status)</Col><Col span='12' style='text-align: center;'>{{orderStatus(order.orderStatus)}}</Col></Row> -->
	    	<Row class='xs-cells-item'>
	    		<Col span='8' style='text-align: left'><Button type='text' :disabled='disabledReturn(order)' @click='returnSales(order)'>{{returnTitle(order.orderCancelStatus)}}</Button></Col>
	    		<Col span='8' style='text-align: center;'><Button type='text' :disabled='!canCancelOrder(order)'  @click='cancelOrder(order)'>取消訂單</Button></Col>
	    		<Col span='8' style='text-align: right;'><Button type='text' @click='showDetail(order)'>查看(Detailed)</Button></Col>
	    	</Row>
	    </div>
	    <div class="page">
			<Button @click='changePage(-1)' :disabled='page==0' class='goon-btn' size='large' type='primary'>上一頁(Last Page)</Button>
			&nbsp;
			<Button @click='changePage(1)' :disabled='nextBtn' class='goon-btn' size='large' type='primary'>下一頁(Next Page)</Button>
		</div>
	</div>
	
	
</template>

<script>
	import {
	    mapState,
	    mapActions,
	    mapMutations,
	    mapGetters
	} from 'vuex';
	import {cvoUrl} from '@/config/env'
	import util from '@/config/util';
	export default {
		data(){
			return {
				page:0,
				loading:true,
				btnloading:false,
				nextBtn:true,
				search:{
					orderNo:null,
					channel:null,
					beginTime:null,
					endTime:null,
					time:null,
					orderStatus:null,
					PageIndex:0,
					PageSize:20,
				},
				searchParam:{
					orderNo:null,
					channel:null,
					orderStatus:null,
					BeginTime:null,
					EndTime:null,
					PageIndex:0,
					PageSize:20,
					argDoCount:0,
				},
				columns:[
					{
                        key: 'createTime',
                        renderHeader:(h,index)=>{
                        	return h('div',[
                        		h('div',null,'訂單日期'),h('div',null,'Order Date')])
                        }
                    },

                    {
                        key: 'orderId',
                        renderHeader:(h,index)=>{
                        	return h('div',[
                        		h('div',null,'訂單編號'),h('div',null,'Order Number')])
                        }
                    },
                    {
                        key: 'total',
                        renderHeader:(h,index)=>{
                        	return h('div',[
                        		h('div',null,'訂單金額/PV'),h('div',null,'Order Amount/PV')])
                        },
                        render:(h,params)=>{
                        	let innerHtml = `HK$${params.row.total} / ${params.row.PV}`
                        	return h('div',null,innerHtml);
                        }
                    },{
                        key: 'action',
                        width: 150,
                        align: 'center',
                        renderHeader:(h,index)=>{
                        	return h('div',[
                        		h('div',null,'取消訂單'),h('div',null,'Cancel Order')])
                        },
                        render: (h, params) => {
                        	let title = params.row.orderStatus == 30 ? '取消成功':'取消訂單'
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        size: 'small',
                                        disabled:!this.canCancelOrder(params.row)
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                        	this.cancelOrder(params.row)
                                        }
                                    }
                                }, title)
                            ]);
                        }
                    },{
                        key: 'action',
                        width: 150,
                        align: 'center',
                        renderHeader:(h,index)=>{
                        	return h('div',[
                        		h('div',null,'退貨'),h('div',null,'Returned Purchase')])
                        },
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        size: 'small',
                                        disabled:this.disabledReturn(params.row)
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                        	this.returnSales(params.row)
                                        }
                                    }
                                }, this.returnTitle(params.row.orderCancelStatus))
                            ]);
                        }
                    },{
                        key: 'action',
                        width: 150,
                        align: 'center',
                        renderHeader:(h,index)=>{
                        	return h('div',[
                        		h('div',null,'明細'),h('div',null,'Detail')])
                        },
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        size: 'small'
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.showDetail(params.row)
                                        }
                                    }
                                }, '查看(Detailed)')
                            ]);
                        }
                    }
                ],
                orders:[],
                showOrders:[],
                total:0,
                currentPage:1,
	       	}
		},
		props:{
			beginTime:{
				type:Date,
			},
			endTime:{
				type:Date,
			},
		},
		components:{
		},
		created(){
			this.$nextTick(function() {
	        });
		},
		computed: {
			screenW(){
				return document.body.clientWidth;
			},
			...mapState({
				token: state => state.common.userToken,
			}),
	    },
		watch:{
		},
		methods:{
			...mapActions([
				'getOrdersAction',
				'cancelHistoryOrderAction',
				'getWXOrderDetailAction',
			]),
			...mapMutations(["SAVE_ORDER"]),
			canCancelOrder(order){
				let now = new Date()
				let createTime = Date.fromStr(order.createTime)
				return order.orderStatus == 20 && order.shipMethod == '501' && now - createTime < 1800000
			},
			disabledReturn(order){
				let now = new Date()
				let createTime = Date.fromStr(order.createTime)
				return order.orderCancelStatus == 6 || order.orderStatus != 60 || order.channel.toLowerCase() == 'oms' || now - createTime < 1800000 || order.shipMethod != '501'
			},
			orderStatus(status){ //orderStatus
				if (status == '20'||status=='1') return '已發貨';
				if (status == '30') return '訂單取消';
				if (status == '40'||status == '50'||status == '60') return '配送中';
				return '其他';
			},
			returnTitle(status){ //orderCancelStatus
				switch(status){
					case 1:
						return '退貨申請'
					case 2:
						return '申請中'
					case 3:
						return '已申請'
					case 4:
						return '處理中'
					case 5:
						return '退貨完成'
					case 6:
						return '不能退貨'
				}
			},
			returnSales(order){
				location = `${cvoUrl}/vo/index.html#/orders/refunds?orderNo=${order.orderId}-${order.origOrderNo}&channel=${order.channel}&token=${this.token}`
			},
			cancelOrder(order) {

				this.$Modal.confirm({
                    title: '確認取消？',
                    cancelText:'不取消',
                    content: `<p>確認取消訂單：${order.orderId}</p><p>取消成功後，訂單款項及使用點數積分1個工作日左右原路退回支付賬戶</p>`,
                    onOk:async () => {
                    	let origOrder = await this.getWXOrderDetailAction(order.origOrderNo)
                    	let payTime = origOrder.delivery[0].PayTime
                    	let date = Date.fromStr(payTime)
                    	let now = new Date()
                    	if (now - date > 1800000) {
                    		this.$Message.error('已經超出取消時間，請收到貨後走退貨流程')
                    	} else {
	                    	let response = await this.cancelHistoryOrderAction(order.orderId)
	                    	if (response.isOK) {
	                    		this.$Message.success('訂單取消成功')
	                    		this.initData()
	                    	}else {
	                    		this.$Message.error('作廢失敗，請收到貨後走退貨流程')
	                    	}
                    	}
                    	
                    },
                    onCancel: () => {
                        
                    }
                });
			},
			showDetail(order){
				this.SAVE_ORDER(order);
				this.$router.push(`/order/omsdetail?orderNo=${order.orderId}&channel=${order.channel}`)
			},
			reloadData(){
				this.page = 0
				this.initData()
			},
			async initData(){
				this.loading = true;
				this.search.beginTime=this.beginTime;
				this.search.endTime = this.endTime;
				this.searchParam.BeginTime = util.formatDate.format(this.beginTime);
				this.searchParam.EndTime = util.formatDate.format(this.endTime);
				this.searchParam.orderStatus = '';
				let response = await this.getOrdersAction(this.searchParam);
				if (response) {
					this.orders = response;
					this.nextBtn = response.length <= 10
					this.showOrders = this.orders.slice(this.page * 10, this.page * 10+10)
					this.total = response.length;
				}
				this.loading = false;

			},
			async changePage(value){
				this.page += value
				this.nextBtn = this.orders.length <= this.page * 10
				this.showOrders = this.orders.slice(this.page*10, (this.page + 1)*10);
			}

		},
	}
</script>

<style lang="scss" scoped>
@import 'src/style/common';
	.search {
		margin-top: 0.5rem;
		margin-bottom: 0.2rem;
	}
	.table {
		margin-bottom: 0.3rem;
	}
	.page {
		margin: 0.2rem auto;
		text-align: center;

	}
	.xs-orders {
		color: #495060;
		font-size: 0.65rem;
		background-color: #fefefe;
		border: 1px solid rgba(0, 0, 0, 0.05);
		margin-bottom: 0.3rem;
	}
	.xs-order-item {
		margin-bottom: 0.2rem;
	}
	.xs-cells {
		padding: 10px;
	}


</style> 